import CalendarWhiteEvents from '../../assets/img/calendarWhiteEvents.svg';
import { useState, useEffect } from "react";
import DrawerUI from "../../components/ui/Drawer";
import { useNavigate } from 'react-router-dom';
import { UserMenu } from '../../components';
import { StorageService } from '../../application/services';
import { ServiceProxy } from '../../ServiceProxy';
import { Overlay } from '../../components';
import { withErrorHandler } from '../../components';
import axios from 'axios';
import ReactTable from '../../components/application/Table/ReactTable';


const FinancePage = () => {
    const navigate = useNavigate()
    const [close, setClose] = useState(false)
    const [events, setEvents] = useState([])
    const [purchasesData, setPurchasesData] = useState([])

    const [loading, setLoading] = useState(true)

    const logout = () => {
        StorageService.clear()
        navigate('/')
    }
    const getActiveEvents = () => {
        Promise.all([
            ServiceProxy.EventsService.getUserEvents({ is_active: true }),
            ServiceProxy.EventsService.getUserEvents({ is_active: false })
        ])
            .then(([activeResponse, inactiveResponse]) => {
                if (activeResponse?.data && inactiveResponse?.data) {
                    const activeEvents = activeResponse.data.results
                    const inactiveEvents = inactiveResponse.data.results
                    setEvents([...activeEvents, ...inactiveEvents])
                    setLoading(false)
                }
            })
            .catch(e => {
                console.error({ e })
                setLoading(false)
            })
    }
    const getPurchases = (params) => {
        setLoading(true)
        ServiceProxy.PurchaseService.listPurchases(params)
            .then(response => {
                if (response && response.data) {
                    const result = response.data
                    setPurchasesData(result.results)
                    setLoading(false)
                }
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            })
    }

    useEffect(() => {
        setLoading(true)
        getActiveEvents()
        getPurchases()
        setLoading(false)
    }, []);

    const columns = [
        { accessor: 'purchase_uuid', Header: 'UUID'},
        { accessor: 'first_name', Header: 'First Name'},
        { accessor: 'last_name', Header: 'Last Name' },
        { accessor: 'quantity', Header: 'Quantity' },
        { accessor: 'price', Header: 'Price' },
        { accessor: 'payment_method', Header: 'Payment Method'},
        { accessor: 'payment_status', Header: 'Payment Status' },
    ];

    return (
        <div className="container-fluid">
            <div className="row">
                <DrawerUI className='drawer' activeTab={6} activeItem={6} openList={6} close={close} setClose={setClose} style={{ width: close && '5rem' }} />
                    <div className={close ? "col width-colum" : "col drawer-in-small width-colum"}>
                        <div className="my-events container">
                            <div>
                                <div className="row">
                                    <div className='d-flex gap-2 navUser justify-content-end m-1'>
                                        <UserMenu logout={logout} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <p className='create-title'><img src={CalendarWhiteEvents} alt="CalendarWhiteEvents" />Finance</p>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-3">
                                        <select defaultValue="all" className="form-select" onChange={(e) => {
                                            getPurchases({ event: e.target.value });
                                            // getOrganizationStatistics(e.target.value);
                                        }}>
                                            <option value="all" disabled>Select Event</option>
                                            {events.map((org) => (
                                                <option key={org.id} value={org.id}>{org.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                {loading ? <Overlay /> :
                                    <div className="row">
                                        <div className="col">
                                            <ReactTable columns={columns} data={purchasesData} columnFilter={["payment_method", "payment_status"]} />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    )
}
export const Finance = withErrorHandler(FinancePage, axios)
